import PropTypes from 'prop-types';
import PencilIcon from './PencilIcon';
import './ScanCardTitle.scss';

/**
 * ScanCardTitle component - displays the scan name with edit icon and overflow ellipsis
 * @param {string} name - The scan name to display
 * @returns React component that renders the title section
 */
const ScanCardTitle = ({ name }) => {
  return (
    <div className="scan-card-title-section">
      <div className="scan-card-title">
        <span className="scan-card-title-text">{name}</span>
        <PencilIcon />
      </div>
    </div>
  );
};

ScanCardTitle.propTypes = {
  name: PropTypes.string.isRequired
};

export default ScanCardTitle;
